import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../Styles/Openings.css";

const JobDetails = () => {
  const { id } = useParams();
  const [jobData, setJobData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [successMessage, setSuccessMessage] = useState("");
  const [formData, setFormData] = useState({
    Job_Role: "",
    Full_Name: "",
    Email: "",
    PhoneNumber: "",
    subject: "",
    Message: "",
    Resume: null,
  });

  useEffect(() => {
    if (!id) return;

    setLoading(true);
    fetch(`/prosapiens-cms/public/api/careers/${id}`)
      .then((res) => res.json())
      .then((data) => {
        let contentHTML = data.content?.job_points || "";
        contentHTML = contentHTML.replace(/<h[1-2][^>]*>.*?<\/h[1-2]>/i, "");

        setJobData({
          ...data.content,
          job_points: contentHTML
        });

        // Pre-fill Job Role
        setFormData((prev) => ({
          ...prev,
          Job_Role: data.content?.job_title || ""
        }));

        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching job details:", err);
        setLoading(false);
      });
  }, [id]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = new FormData();
    Object.keys(formData).forEach((key) => {
      payload.append(key, formData[key]);
    });

    try {
      const res = await fetch(
        "/prosapiens-cms/public/api/submitpost",
        {
          method: "POST",
          body: payload,
        }
      );

      if (!res.ok) {
        throw new Error("Failed to submit form");
      }

      setSuccessMessage("✅ Your application has been submitted successfully!");
      // Reset form
      setFormData({
        Job_Role: jobData?.job_title || "",
        Full_Name: "",
        Email: "",
        PhoneNumber: "",
        subject: "",
        Message: "",
        Resume: null,
      });
    } catch (err) {
      console.error(err);
      setSuccessMessage("❌ Something went wrong. Please try again.");
    }
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  if (!jobData) {
    return <p>Job not found.</p>;
  }

  return (
    <>
      <section className="contact-us">
        <div className="overlay container">
          <div className="hero-text" />
        </div>
      </section>

      <section className="contact-section">
        <div className="container">
          <div className="contact">
            <div className="contact-info">
              <h1>{jobData.job_title}</h1>
              <p><strong>Job Location:</strong> {jobData.location_name}</p>
              <p><strong>Experience:</strong> {jobData.experience} years</p>
              <p><strong>Salary:</strong> {jobData.salary_range_text}</p>
              <p><strong>Job Type:</strong> {jobData.job_type_name}</p>

              <div dangerouslySetInnerHTML={{ __html: jobData.job_points }} />

              <div className="section">
                <h2>Interested?</h2>
                <p>Drop your resume now!</p>
                <a href="mailto:hr@example.com" className="cta">
                  Apply Now
                </a>
              </div>
            </div>

            <div className="contact-form">
              <h3>Get in touch</h3>
              <form onSubmit={handleSubmit} encType="multipart/form-data">
                <label>Job Role *</label>
                <input
                  type="text"
                  name="Job_Role"
                  value={formData.Job_Role}
                  readOnly
                  required
                />

                <label>Full Name *</label>
                <input
                  type="text"
                  name="Full_Name"
                  value={formData.Full_Name}
                  onChange={handleChange}
                  required
                />

                <label>Email *</label>
                <input
                  type="email"
                  name="Email"
                  value={formData.Email}
                  onChange={handleChange}
                  required
                />

                <label>Phone</label>
                <input
                  type="tel"
                  name="PhoneNumber"
                  value={formData.PhoneNumber}
                  onChange={handleChange}
                />

                <label>Subject *</label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />

                <label>Message *</label>
                <textarea
                  name="Message"
                  rows="5"
                  value={formData.Message}
                  onChange={handleChange}
                  required
                ></textarea>

                <label>Resume *</label>
                <input
                  type="file"
                  name="Resume"
                  accept=".pdf,.doc,.docx"
                  onChange={handleChange}
                  required
                />

                <button type="submit">SUBMIT</button>

                {/* Success message below button */}
                {successMessage && (
                  <p style={{ marginTop: "10px", color: successMessage.startsWith("✅") ? "green" : "red" }}>
                    {successMessage}
                  </p>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default JobDetails;
